export const JOURNEY_ITEMS = [
  {
    key: 'founding',
    image:
      '/uploads/January2022/Anh_chup_Man_hinh_2022-01-04_luc_13.52_1_(1).jpg',
  },
  {
    key: 'hcm_office',
    image: '/uploads/January2022/image_73_(1).jpg',
  },
  {
    key: 'seed_funding',
    image: '/uploads/January2022/image_74_(1).jpg',
    yellow: true,
  },
  {
    key: 'startup_wheel',
    image: '/uploads/January2022/image_76.jpg',
    yellow: true,
  },
  {
    key: 'startup_viet',
    yellow: true,
  },
  {
    key: 'revenue_2020',
    yellow: true,
  },
  {
    key: 'pre_a_funding',
    image: '/uploads/January2022/image_78.jpg',
    imageStyle: { height: '100px' },
    green: true,
  },
  {
    key: 'shark_tank',
    image: '/image/October2022/mceclip0_28.jpg',
    imageStyle: { height: '80px' },
    green: true,
  },
  {
    key: 'esop_1',
    green: true,
  },
  {
    key: 'revenue_2021',
    green: true,
  },
  {
    key: 'internal_comms',
    image: '/image/September2022/mceclip0_48.png',
    imageStyle: { height: '60px' },
    red: true,
  },
  {
    key: 'stic_vic_funding',
    gridImages: [
      {
        src: '/image/September2022/mceclip1_1.jpg',
        alt: 'STIC',
        style: { maxHeight: '80px', marginBottom: '26px' },
      },
      {
        src: '/image/September2022/mceclip2_37.png',
        alt: 'VIC',
        style: { maxHeight: '130px' },
      },
    ],
    red: true,
  },
  {
    key: 'series_a',
    images: [
      {
        src: '/image/September2022/mceclip3_41.png',
        alt: 'Access Ventures',
        style: { height: '60px', maxWidth: '150px', objectFit: 'contain' },
      },
      {
        src: '/image/September2022/mceclip6_55.png',
        alt: 'Access Ventures',
        style: { maxWidth: '100px', objectFit: 'contain', zIndex: 1 },
      },
      {
        src: '/image/September2022/mceclip4_80.png',
        alt: 'Access Ventures',
        style: {
          maxWidth: '150px',
          objectFit: 'contain',
          transform: 'scale(1.7)',
          zIndex: 0,
        },
      },
      {
        src: '/image/September2022/mceclip7_30.png',
        alt: 'Access Ventures',
        style: { height: '100px', zIndex: 1 },
      },
    ],
    imageContainerStyle: { display: 'flex', overflow: 'hidden' },
    red: true,
  },
  {
    key: 'disney_esop_2',
    image: '/image/September2022/mceclip5_41.png',
    imageStyle: { height: '80px' },
    red: true,
  },
  {
    key: 'order_record',
    red: true,
  },
  {
    key: 'gsr_funding',
    image: '/image/September2022/mceclip9_46.png',
    imageStyle: { height: '50px' },
    red: true,
  },
  {
    key: 'hanoi_office',
    red: true,
  },
  {
    key: 'hcm_office_84rising',
    red: true,
  },
  {
    key: 'revenue_2022',
    red: true,
  },
  {
    key: 'vietful',
    green: true,
  },
  {
    key: 'running',
    image: '/image/February2024/mceclip0_12.png',
    imageStyle: { height: '80px' },
    green: true,
  },
  {
    key: 'gym',
    image: '/image/February2024/mceclip1_81.png',
    imageStyle: { height: '80px', maxWidth: '150px', objectFit: 'contain' },
    green: true,
  },
  {
    key: 'esop_3',
    image: '/image/February2024/mceclip2_28.jpg',
    green: true,
  },
  {
    key: 'forbes',
    image: '/image/February2024/mceclip3_91.jpg',
    green: true,
  },
  {
    key: 'achievements',
    image: '/image/February2024/mceclip4_17.png',
    imageStyle: { height: '70px' },
    green: true,
  },
  {
    key: 'order_record_2',
    green: true,
  },
  {
    key: 'revenue_2023',
    green: true,
  },
  {
    key: 'operation_smile',
    image: '/image/July2024/mceclip2_54.png',
    imageStyle: { height: '40px' },
    pink: true,
  },
  {
    key: 'birthday_5',
    image: '/image/July2024/mceclip1_67.png',
    imageStyle: { height: '40px' },
    pink: true,
  },
  {
    key: 'south_center',
    pink: true,
  },
  {
    key: 'coolclub_office',
    image: '/image/July2024/mceclip3_36.png',
    imageStyle: { height: '40px' },
    pink: true,
  },
  {
    key: 'north_center',
    pink: true,
  },
  {
    key: 'esop_4',
    pink: true,
  },
  {
    key: 'warm_clothes',
    image: '/image/January2025/mceclip0_33.jpg',
    pink: true,
  },
  {
    key: 'vertex_funding',
    images: [
      {
        src: '/image/January2025/mceclip1_16.png',
        alt: 'vertex ventures',
        style: { height: '200px' },
      },
      {
        src: '/image/January2025/mceclip2_44.png',
        alt: 'kairous capital',
        style: { maxHeight: '100px' },
      },
    ],
    pink: true,
  },
  {
    key: 'amazon',
    image: '/image/January2025/mceclip0_40.jpg',
    pink: true,
  },
  {
    key: 'women_activewear',
    image: '/image/2026/03/18/image_6.png',
    yellow: true,
  },
  {
    key: 'amazon_1m',
    image: '/image/2026/03/18/Frame_1.png',
    yellow: true,
  },
  {
    key: 'series_c',
    image: '/image/2026/03/18/image_8.jpg',
    yellow: true,
  },
  {
    key: 'amazon_rising_star',
    image: '/image/2026/10/07/amazon_rising_star_2025.jpg',
    yellow: true,
  },
  {
    key: 'offline_store',
    image: '/image/2026/03/18/image_10.jpg',
    pink: true,
  },
]
